let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jtAqv")).then(() => parcelRequire('iSeW0'));